import React, { useEffect } from "react";
import { Button, Grid, Paper, Stack, Typography } from "@mui/material";
import QualificationTableComponent from "../../../components/admin/qualification-manager/QualificationTable";
import { QualificationAddDrawer } from "../../../components/admin/qualification-manager/QualificationAddDrawer";
import { useGetQualificationListQuery } from "../../../store/masters/mastersApis";
import { SearchRecords } from "../../../components/Common/SearchRecords";
import { Add } from "@mui/icons-material";
import { QualificationInitialForm } from "../../../store/masters/mastersSlice";

const QualificationManagerContainer = (props) => {
    const { showDrawer, formType, initialValues, pagination } = props;
    const { isLoading, data: qualification, isFetching } = useGetQualificationListQuery(pagination);

    const handleAddQualification = () => {
        props.changeMastersInitialState({
            showDrawer: true,
            formType: "Add",
            initialValues: QualificationInitialForm
        })
    }

    useEffect(() => {
        props.handlePaginationState({
            pageNo: 0,
            limit: 10,
            sortBy: -1,
            sortField: "createdAt",
            keywords: ""
        })
    }, []);

    const handlePagination = (setting) => {
        props.handlePaginationState(setting);
    }

    const handleDrawerClose = () => {
        props.changeMastersInitialState({ showDrawer: false, formType: "", initialValues: QualificationInitialForm })
    }

    const handleQualificationEdit = (data, type) => {
        let payload = { ...data };
        delete payload.createdAt;
        props.changeMastersInitialState({ showDrawer: true, formType: type, initialValues: payload })
    }

    return (
        <Stack spacing={1}>
            <Paper sx={{ marginBottom: "24px", padding: 1.5 }}>
                <Grid container justifyContent="space-between">
                    <Grid item sx={{ alignSelf: "center" }}>
                        <Typography variant="h6">List of Qualification</Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            disableElevation
                            variant="contained"
                            sx={{ borderRadius: "50px" }}
                            onClick={() => handleAddQualification()}
                            startIcon={<Add />}
                        >
                            Add
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            <Grid container>
                <SearchRecords handlePagination={handlePagination} pagination={pagination} />
                <Grid item xs={12}>
                    <Paper
                        sx={{ p: 2, color: "#071B2A", fontWeight: "400" }}
                        elevation={0}
                    >
                        <QualificationTableComponent fetching={isFetching} edit={(val, type) => handleQualificationEdit(val, type)} loading={isLoading} count={qualification?.count || 0} data={qualification?.result || []} pagination={pagination} handlePagination={(val) => handlePagination(val)} />
                    </Paper>
                </Grid>
            </Grid>

            {/* add taf drawer */}
            <QualificationAddDrawer show={showDrawer} close={handleDrawerClose} formType={formType} initialValues={initialValues} />

        </Stack >
    );
}

export default QualificationManagerContainer;